/* eslint-disable react/prop-types */
import React from 'react'
import { useTranslation } from 'react-i18next'

import './ConfigPageItem.scss'

const ConfigPageItem = ({
  screenName,
  screenDesc,
  screenTitle,
  checked,
  handleCheck,
  thumbnail,
}) => {
  const { t } = useTranslation()

  const checkedClass = checked ? ' config-item-checkbox-checked' : ''

  return (
    <div className='config-item'>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div
        className={'config-item-checkbox' + checkedClass}
        onClick={() => handleCheck(screenTitle)}>
        {checked ? (
          <i className='fa fa-check' aria-hidden='true' />
        ) : null}
      </div>
      <img src={thumbnail} alt={t('proShop.configItem.thumbnailAlt', { screenTitle })} className='config-item-preview-img' />
      <div>
        <h3 className='config-item-label'>{screenName}</h3>
        <p className='config-item-desc'>{screenDesc}</p>
      </div>
    </div>
  )
}

export default ConfigPageItem
